module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-503.8f043ab.woff2";